import React, { FC } from "react";
import useTranslation from "next-translate/useTranslation";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Grid } from "@/components/Grid";
import { Heading } from "@/components/Heading";
import { Accordion } from "@/components/Accordion";

type IFigmaBackupFaqSection = {
  translationNamespace?: string;
};

const FAQ_KEYS_LEFT = [
  "whyBackup",
  "backupDuration",
  "howToRestore",
  "areFilesSecure",
];
const FAQ_KEYS_RIGHT = [
  "backupCycleDuration",
  "trial",
  "customStorage",
  "figjam",
  "plugin",
];

export const BackupFaqSection: FC<IFigmaBackupFaqSection> = ({
  translationNamespace = "section/figmaBackupFaq",
}) => {
  const { bp, colors } = useTheme();
  const { css } = useFela();
  const { t } = useTranslation(translationNamespace);

  // Namespaces reusing this section (e.g. airtable) don't define every key —
  // skip entries whose translation is missing instead of rendering the raw key
  const renderAccordions = (keys: string[]) =>
    keys
      .filter(key => t(`${key}.question`) !== `${key}.question`)
      .map(key => (
        <Accordion
          key={key}
          title={t(`${key}.question`)}
          longAnswer={t(`${key}.answer`)}
        />
      ));

  return (
    <Grid
      customStyle={{
        flexDirection: "column",
        [bp.FROM_DESKTOP]: {
          padding: "56px 20px 36px",
        },
      }}
      id="FigmaBackupFaqSection"
    >
      <Heading
        as="h2"
        customStyle={{ color: colors.CHARCOAL, textAlign: "center" }}
      >
        {t("title")}
      </Heading>
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          [bp.FROM_TABLET]: {
            flexDirection: "row",
          },
        })}
      >
        <div
          className={css({
            width: "100%",
            [bp.FROM_TABLET]: {
              width: "calc(50% - 21px)",
              display: "inline-block",
              marginRight: 21,
            },
          })}
        >
          {renderAccordions(FAQ_KEYS_LEFT)}
        </div>
        <div
          className={css({
            width: "100%",
            [bp.FROM_TABLET]: {
              width: "calc(50% - 21px)",
              display: "inline-block",
            },
          })}
        >
          {renderAccordions(FAQ_KEYS_RIGHT)}
        </div>
      </div>
    </Grid>
  );
};
